import GuaziHeader from '@/components/feature/GuaziHeader';
import GuaziFooter from '@/components/feature/GuaziFooter';
import GuaziDownloadHero from '@/pages/guazi-download/guazi-components/GuaziDownloadHero';
import GuaziInstallSteps from '@/pages/guazi-download/guazi-components/GuaziInstallSteps';
import GuaziDeviceSupport from '@/pages/guazi-download/guazi-components/GuaziDeviceSupport';
import GuaziDownloadFaq from '@/pages/guazi-download/guazi-components/GuaziDownloadFaq';
import { useGuaziSeo } from '@/hooks/guaziUseSeo';

export default function GuaziDownloadPage() {
  useGuaziSeo({
    title: '瓜子影视新版下载-瓜子影视APP下载官网-瓜子影视',
    keywords: '瓜子影视新版下载,瓜子影视APP下载官网',
    description: '瓜子影视APP下载官网，提供瓜子影视APP最新版下载，支持安卓手机安装。海量高清影视随时看，更新及时，播放流畅。官方下载入口，安装便捷，安全稳定，欢迎访问瓜子影视APP下载页。',
    canonical: 'https://www.guaziyingshi.net/download',
  });

  return (
    <div className="w-full min-h-screen bg-background-50">
      <GuaziHeader />
      <main>
        <GuaziDownloadHero />
        <GuaziInstallSteps />
        <GuaziDeviceSupport />
        <GuaziDownloadFaq />
      </main>
      <GuaziFooter />
    </div>
  );
}